import type { FspParts, SignalObject } from "./schema";

const LAMBDA = 0.35;

export function clamp01(n: number) {
  return Math.max(0, Math.min(1, n));
}

export function scoreFsp(p: FspParts): number {
  return (
    0.2 * p.velocity +
    0.15 * p.acceleration +
    0.15 * p.convergence +
    0.15 * p.djAdoption +
    0.1 * p.diffusion +
    0.1 * p.socialReuse +
    0.1 * p.technology +
    0.05 * p.novelty
  );
}

export function applyMomentum(obj: SignalObject, next: number): SignalObject {
  const momentum = next + LAMBDA * (next - obj.fspPrev);
  return {
    ...obj,
    fspPrev: obj.fsp,
    fsp: clamp01(next),
    momentum: clamp01(momentum),
  };
}

export function partsOf(obj: SignalObject): FspParts {
  return {
    velocity: obj.velocity,
    acceleration: obj.acceleration,
    convergence: obj.convergence,
    djAdoption: obj.djAdoption,
    diffusion: obj.diffusion,
    socialReuse: obj.socialReuse,
    technology: obj.technologyEnablement,
    novelty: obj.novelty,
  };
}

export function fspLabel(n: number): string {
  const pct = Math.round(n * 100);
  if (pct >= 75) return `${pct} — strong chance it grows`;
  if (pct >= 55) return `${pct} — worth watching`;
  if (pct >= 35) return `${pct} — early / mixed`;
  return `${pct} — weak signal`;
}

export const PART_PLAIN: { key: keyof FspParts; label: string }[] = [
  { key: "velocity", label: "How fast it is moving" },
  { key: "acceleration", label: "Whether it is speeding up" },
  { key: "convergence", label: "Sounds mixing together" },
  { key: "djAdoption", label: "DJs picking it up" },
  { key: "diffusion", label: "Spread across cities" },
  { key: "socialReuse", label: "People sharing and reusing it" },
  { key: "technology", label: "New tools making it easier" },
  { key: "novelty", label: "How new it feels" },
];
